/** 本期暂缓的能力保留实现；恢复时统一调整此配置并验证对应流程。 */
export const orderImportFeatures = {
  conditionFilters: false,
  sorting: false,
  errorCategoryFilter: false,
  bulkApplyFirst: false,
};
